import ArchivesListRow from "./ArchivesListRow";


const ArchivesListTable = ({archives}) => {
  return (
    <div>
      {archives.length > 0 && (
        <table className="w-full text-sm border-separate border-spacing-x-6">
          <thead>
            <tr className="text-gray-600 border-b">
              <th className="py-2 text-left">Emp_ID</th>
              <th className="py-2 text-left">Name</th>
              <th className="py-2 text-left">Department</th>
              <th className="py-2 text-left">Designation</th>
              <th className="py-2 text-left">Employment Type</th>
              <th className="py-2 text-left">Duration</th>
            </tr>
          </thead>
          <tbody>
            {archives.map((emp) => (
              <ArchivesListRow
                emp={emp}
                key={emp.id}
              />
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default ArchivesListTable